import { useReducer, useState } from "react";
import { getItems, createItem, updateItem, defaultItem, deleteItem, reducer, getAreas,
    createPaso, updatePaso, destroyPaso, defaultPaso, changeno
} from "./functions";
import { useNotifications } from "../../common/useNotifications";

export const useTramites= () => {
    const { showSuccess, showInfo, showError, confirmDelete } = useNotifications();
    const [formVisibility, setFormVisibility] = useState(false);
    const [items, dispatch] = useReducer(reducer);
    const [editItem, setEditItem] = useState(defaultItem);
    const [loading, setLoading] = useState(false);
    const [tableParams, setTableParams] = useState({
        pagination: { "current": 1, "pageSize": 10, "total": 0 },
        filters: {},
        sorter: {},
    });
    const [areas, setAreas] = useState([]);
    
    const [editPaso, setEditPaso]  = useState(defaultPaso);
    const [showFormPaso, setShowFormPaso] = useState(false);

    const fillItems = async (params = tableParams) => {
        try {
            setLoading(true);
            let { data } = await getItems(params);
            let { rows, total, current } = data;

            dispatch({ type: "FILL", payload: rows });
            setTableParams(prev => {
                return {
                    ...prev,
                    ...params,
                    pagination: {
                        ...prev.pagination,
                        ...params.pagination,
                        total: total,
                        current: current
                    }
                }
            });
        } catch (error) { throw new Error(error); }
        finally { setLoading(false); }
    }

    const fillAreas = async () => {
        try {
            let res = await getAreas();
            setAreas(res.data.rows);
        } catch (error) { console.log(error.message); }
    }

    const newItem = () => { 
        setEditItem(defaultItem); showForm(); 
    }

    const handle_save = async (item) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (item === editItem) { showInfo("No hay cambios."); resolve(); return; }
                setLoading(true);
                let item_action = (item.id === 0) ? createItem(item) : updateItem(item);
                let res = await item_action;
                if (item.id === 0) { 
                    item.id = res.data.id;
                    fillItems();
                    setEditItem({...item});
                } else { dispatch({ type: "UPDATE", payload: item }); }
                showSuccess("¡Guardado correcto!");
                resolve();
            } catch (e) {
                showError(e.message);
                reject(e);
            } finally { setLoading(false); }
        });
    }

    const selectItem = (item) => {
        setEditItem({...item, codigo: item.codigo ?? "", area_id: parseInt(item.area_id)});
        showForm();
    }

    const handle_delete = async (id) => {
        if(await confirmDelete(id)) {
            await deleteItem(id);
            fillItems();
        }
    }

    const showForm = () => {
        setFormVisibility(true);
    }

    const hideForm = () => {
        setFormVisibility(false);
    }

    const handleTableChange = (pagination, filters, sorter, extra) => {
        let params = {
            ...tableParams,
            pagination,
            filters,
            sorter,
        };
        fillItems(params);
    }

    const newPaso = () => { 
        setEditPaso({...defaultPaso, tramite_id: editItem.id}); setShowFormPaso(true); 
    }
    const selectPaso = (item) => {
        setEditPaso({...item, tramite_id: editItem.id});
        setShowFormPaso(true);
    }
    const handle_save_paso = (item) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (item === editPaso) { showInfo("No hay cambios."); resolve(); return; }
                setLoading(true);
                let item_action = (item.id === 0) ? createPaso(item) : updatePaso(item);
                let res = await item_action;
                if (item.id === 0) { 
                    item.id = res.data.id;
                    item.no = res.data.no;
                    //dispatch({type: 'ADD_PASO', payload: item});
                   await fillItems();
                   editItem.pasos = [...editItem.pasos, item];
                } else { 
                    await fillItems();
                    //dispatch({type: 'UPDATE_PASO', payload: item}); 
                    editItem.pasos = editItem.pasos.map(p => ((p.id === item.id)? item: p));
                }
                showSuccess("¡Guardado correcto!");
                resolve();
            } catch (e) {
                console.error(e);
                showError(e.message);
                reject(e);
            } finally { setLoading(false); }
        });
    }
    const handle_del_paso = async (item) => {
        if(await confirmDelete(item.id)) {
            let res = await destroyPaso(item.id);
            editItem.pasos = res.data;
            fillItems();
        }
    }

    const hideFormPaso = () => {
        setShowFormPaso(false);
    }
    const changeNo = async (id, action) => {
        let res = await changeno({
            tramite_id: editItem.id,
            paso_id: id,
            action: action
        });
        setEditItem(prev => ({...prev, pasos: res.data}));
        fillItems();
    }

    return {
        items: {
            items,
            editItem,
            selectItem,
            fillItems,
            handle_save,
            handle_delete,
            newItem,
        },
        areas: {
            fillAreas,
            areas,
        },
        formParams: {
            showForm,
            hideForm,
            formVisibility
        },
        pasos: {
            newPaso,
            selectPaso,
            editPaso,
            showFormPaso,
            handle_save_paso,
            handle_del_paso,
            hideFormPaso,
            changeNo
        },
        loading,
        tableParams,
        handleTableChange
    };

}